import Tag from '@rio-cloud/rio-uikit/Tag';
import { FeatureTeaser } from './FeatureTeaser';
import { CustomFormattedMessage, TranslationsKeys } from '../i18n/i18n';

type PartnerCardProps = {
  titleId: TranslationsKeys;
  descriptionId: TranslationsKeys;
  image: string;
  isExternalPartner?: boolean;
  onClick: () => void;
  'data-testid': string;
};

export const PartnerCard = ({
  titleId,
  descriptionId,
  image,
  isExternalPartner = false,
  onClick,
  'data-testid': dataTestId,
}: PartnerCardProps) => (
  <FeatureTeaser
    image={image}
    headline={<CustomFormattedMessage id={titleId} />}
    headlineClassName={'text-size-16 text-medium'}
    content={
      <span
        className={'text-size-14 text-color-darker'}
        data-testid={'partner-description'}
      >
        <CustomFormattedMessage id={descriptionId} />
      </span>
    }
    footer={
      isExternalPartner ? (
        <div className={'display-flex justify-content-end margin-top-10'}>
          <Tag
            size={'small'}
            round={false}
            muted
            className={'text-color-primary border-color-primary margin-top-10'}
            data-testid={'external-partner-badge'}
          >
            <CustomFormattedMessage
              id={'overview.ourPartners.externalPartnerBadge'}
            />
          </Tag>
        </div>
      ) : undefined
    }
    onClick={onClick}
    data-testid={dataTestId}
  />
);
